import { Button, Col, Form, Input, Row } from 'antd';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { registerPlatform } from '../../actions/user';

const PlatformRegistration = () => {
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const dispatch = useDispatch();

    const onFinish = (values: any) => {
        const payload = {
            platformName: values.platformName,
            platformURL: values.platformUrl,
            redirectURLs: values.redirectUrls.split(',').map((url: string) => url.trim()),
            contactEmail: values.contactEmail,
            contactPerson: values.contactPerson,
        };

        dispatch(
            registerPlatform(payload, (response: any) => {
                if (response.status === 201) {
                    navigate('/');
                }
            })
        );
    };

    const onFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
    };

    return (
        <div>
            <div className='authforms'>
                <div className="authHeadings">
                    <button className='btn textAuthHeading' onClick={() => navigate(-1)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <rect x="0.4" y="0.4" width="23.2" height="23.2" rx="11.6" stroke="#F47523" stroke-width="0.8" />
                            <path d="M14 8L10 12L14 16" stroke="#F47523" stroke-width="1.25" stroke-linecap="round" />
                        </svg>
                    </button>
                    <div className="textAuthHeading">Platform <span>Registration</span></div>
                </div>

                <Row>
                    <Col lg={24} md={24} sm={24}>
                        <Form
                            className='formControl'
                            layout="vertical"
                            form={form}
                            onFinish={onFinish}
                            onFinishFailed={onFailed}
                        >
                            <Form.Item
                                name="platformName"
                                className='formControlDesign'
                                label='Platform Name'
                                rules={[{ required: true, message: 'Please input the Platform Name!' }]}
                            >
                                <Input placeholder='Platform Name' />
                            </Form.Item>

                            <Form.Item
                                name="platformUrl"
                                className='formControlDesign'
                                label='Platform URL'
                                rules={[{ required: true, message: 'Please input the Platform URL!' }]}
                            >
                                <Input placeholder='Platform URL' />
                            </Form.Item>

                            <Form.Item
                                name="redirectUrls"
                                className='formControlDesign'
                                label='Redirect URLs (comma-separated)'
                                rules={[{ required: true, message: 'Please input the Redirect URLs!' }]}
                            >
                                <Input placeholder='Redirect URLs' />
                            </Form.Item>

                            <Form.Item
                                name="contactEmail"
                                className='formControlDesign'
                                label='Contact Email'
                                rules={[{ required: true, type: 'email', message: 'Please input a valid Contact Email!' }]}
                            >
                                <Input placeholder='Contact Email' />
                            </Form.Item>

                            <Form.Item
                                name="contactPerson"
                                className='formControlDesign'
                                label='Contact Person'
                                rules={[{ required: true, message: 'Please input the Contact Person!' }]}
                            >
                                <Input placeholder='Contact Person' />
                            </Form.Item>

                            <Button className='btn btn-primary w-100' type="primary" htmlType="submit">
                                Submit
                            </Button>
                        </Form>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default PlatformRegistration;
